import { jsonParse, modifyData } from '@/utils/utils'
import { getCookie, removeCookie, setCookie } from '@/utils/cookie'
import { ref, reactive } from 'vue'

function useUserInfo() {
  return {
    id: '',
    role_id: '',
    creator_id: '',
    role_name: '',
    username: '',
    nickname: '',
    header_url: '',
    token: '',
    updated_at: '',
    created_at: ''
  }
}
const buttonPermissions = ref([])
const allMenus = ref([])
const rules = ref({})
const authPaths = ref([])
const isGetMenu = ref(false)
function setButtonPermissions(menus) {
  if (!menus.length) {
    return (buttonPermissions.value = [])
  }
  const permissions = []
  menus.forEach(item => {
    if (item.type === 2) {
      permissions.push(item.path)
    }
  })
  // console.log("权限按钮", permissions)
  buttonPermissions.value = permissions
}
function setAllMenu(menus) {
  allMenus.value = menus
}
function setAuthPaths(paths) {
  authPaths.value = paths
}
function setRules(rule) {
  rules.value = rule || {}
}
/** cookie 过期天数 */
const day = 3
const millisecond = 24 * 60 * 60 * 1000

const cacheKey = 'sh-user-store'

const cacheData = jsonParse(getCookie(cacheKey))

/**
 * 当前用户信息
 * - 不希望开发者在某个地方设置某个值，所以这里把类型设置为`Readonly`，
 * 只能通过`update`方法去修改，这样确保缓存中的同步修改
 */
const info = reactive(useUserInfo() || {})

/**
 * 更新并同步用户数据
 * - 只修改原本存在的值
 * @param value
 */
function update(value) {
  modifyData(info, value)
  setCookie(cacheKey, JSON.stringify(info), {
    expires: new Date(Date.now() + day * millisecond)
  })
}
/**
 * 更新并同步用户数据
 * - 只修改原本存在的值
 * @param value
 */
update(cacheData)

/**
 * 当前用户相关
 * @returns
 */
export function useCurrentUser() {
  function reset() {
    try {
      modifyData(info, useUserInfo())
      removeCookie(cacheKey)
      allMenus.value = []
      authPaths.value = []
      isGetMenu.value = false
      buttonPermissions.value = []
    } catch (error) {
      console.error(error)
    }
  }

  return {
    info,
    update,
    reset,
    buttonPermissions,
    setButtonPermissions,
    setAllMenu,
    allMenus,
    setRules,
    rules,
    setAuthPaths,
    authPaths,
    isGetMenu
  }
}
